import React from 'react';
import { Link } from 'react-router-dom';

const CGVPage = () => (
  <div className="min-h-screen pt-24 pb-20" data-testid="cgv-page">
    <div className="bg-[#000000] py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-white font-['Playfair_Display']">Conditions Générales de Vente</h1>
      </div>
    </div>
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 prose prose-lg max-w-none">
      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">Article 1 - Objet</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        Les présentes conditions générales de vente régissent les relations contractuelles entre CALVI FISHING et ses clients pour la réservation et la prestation de sorties de pêche en mer au départ du port de Calvi, Corse.
      </p>

      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">Article 2 - Réservation et paiement</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        La réservation d'une sortie de pêche est effective après paiement intégral en ligne par carte bancaire (Visa, Mastercard, American Express, CB) via notre plateforme de paiement sécurisé Square. Un email de confirmation est envoyé au client après validation du paiement. Les réservations effectuées sur place sont payables le jour de la sortie.
      </p>

      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">Article 3 - Tarifs</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        Les tarifs sont indiqués en euros (€) TTC. CALVI FISHING se réserve le droit de modifier ses tarifs à tout moment. Les tarifs applicables sont ceux en vigueur au moment de la réservation :<br /><br />
        - Pêche Découverte (2H) : 90€/pers. | Privatisation : 360€<br />
        - Pêche au Gros 4H : 160€/pers. | Privatisation : 640€<br />
        - Pêche au Gros 6H : 190€/pers. | Privatisation : 760€<br />
        - Pêche Côtière (4H) : 150€/pers. | Privatisation : 600€<br />
        - Pêche Calamar (4H) : 150€/pers. | Privatisation : 600€<br /><br />
        Maximum 4 participants par sortie.
      </p>

      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">Article 4 - Annulation et remboursement</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        <strong>Annulation par le client :</strong><br />
        - Plus de 48 heures avant la sortie : remboursement intégral.<br />
        - Entre 48 et 24 heures : remboursement de 50%.<br />
        - Moins de 24 heures ou absence : aucun remboursement.<br /><br />
        <strong>Annulation par CALVI FISHING :</strong><br />
        En cas de conditions météorologiques défavorables ou de tout autre motif de sécurité, CALVI FISHING se réserve le droit d'annuler ou de reporter la sortie. Le client sera informé dans les meilleurs délais et se verra proposer un report ou un remboursement intégral.
      </p>

      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">Article 5 - Déroulement des sorties</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        Le client doit se présenter au point de rendez-vous (Port de Plaisance de Calvi) 15 minutes avant l'heure de départ. Tout retard pourra entraîner l'impossibilité de participer à la sortie sans remboursement. Le capitaine est seul décideur des conditions de navigation et peut modifier le programme en fonction des conditions météorologiques et de la mer.
      </p>

      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">Article 6 - Sécurité</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        Le bateau est équipé de tous les équipements de sécurité réglementaires. Le matériel de pêche est fourni. Les participants doivent respecter les consignes de sécurité données par le capitaine. Les mineurs doivent être accompagnés d'un adulte responsable. Il est recommandé d'apporter de la crème solaire, un chapeau et une veste coupe-vent.
      </p>

      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">Article 7 - Responsabilité</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        CALVI FISHING est assuré en responsabilité civile professionnelle. La pêche est une activité aléatoire et CALVI FISHING ne garantit pas la prise de poissons. L'absence de prise ne constitue pas un motif de remboursement.
      </p>

      <h2 className="text-2xl font-bold font-['Playfair_Display'] mb-4">Article 8 - Litiges</h2>
      <p className="text-[#4B5563] mb-6 leading-relaxed">
        En cas de litige, le client peut recourir à un médiateur de la consommation. À défaut d'accord amiable, tout litige sera soumis aux tribunaux compétents de Bastia.
      </p>

      <div className="flex gap-4 mt-10 pt-8 border-t border-[#E2E8F0]">
        <Link to="/legal" className="text-[#b7ede0] hover:underline font-medium">Mentions légales</Link>
        <Link to="/privacy" className="text-[#b7ede0] hover:underline font-medium">Politique de confidentialité</Link>
      </div>
    </div>
  </div>
);

export default CGVPage;
